import { createZodFormResolver, lt, useFormControls } from '@mews/framework';
import { WithScope } from '@mews-commander/types';
import { SearchType } from '@mews-commander/enums';
import { FormLayout } from '../../FormLayout';
import { SearchHookField } from '../../../../../components/form/hookFields';
import { GroupMergeFormKeys, groupMergeFormSchema } from './types';
import { useChangeGroupMergeMutation } from './useChangeGroupMergeMutation';

const EMPTY = '';

export const GroupMergeForm = ({ scope, onSuccess }: WithScope & { onSuccess?: () => void }) => {
    const { mutate, isPending } = useChangeGroupMergeMutation({
        groupId: scope,
    });
    const { renderFormContent, reset } = useFormControls({
        onSubmit: (v) => {
            mutate(v, {
                onSuccess: () => {
                    onSuccess?.();
                    reset();
                },
            });
        },
        resolver: createZodFormResolver(groupMergeFormSchema),
        defaultValues: {
            [GroupMergeFormKeys.sourceGroupId]: EMPTY,
        },
        dataTestForm: 'group-merge-form',
    });

    return renderFormContent(
        <FormLayout vertical loading={isPending} submitButtonText={lt('Merge')} title={lt('MergeGroupIntoThis')}>
            <SearchHookField
                data-test-id={GroupMergeFormKeys.sourceGroupId}
                newEntity={false}
                name={GroupMergeFormKeys.sourceGroupId}
                label={lt('ReservationGroupName')}
                searchTypes={[SearchType.ReservationGroup]}
                except={[scope]} // Exclude the current group from the search
            />
        </FormLayout>
    );
};
